import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import CardHeader from '@material-ui/core/CardHeader';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormControl from '@material-ui/core/FormControl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileDownload, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { useHistory } from 'react-router';

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: '0px 1px 10px #dddddd !important',
        marginBottom: '2%',
    },
    cardCustom: {
        padding: '0',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightMedium,
        color: '#4c4c4d',
        fontFamily: 'Rubik',
    },
    accordContentSummary: {
        background: '#f9f9f9',
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        width: '100%',
    },
    btnspace: {
        width: '300px',
        margin: '60px auto 50px auto',
    },
    displayInline: {
        listStyle: 'none',
        display: 'flex',
        justifyContent: 'flex-end',
        margin: 0,
        '& li': {
            display: 'inline-block',
        },
    },
    btnFieldPositionRight: {
        position: 'absolute',
        right: '0',
        top: '20px',
        [theme.breakpoints.down('sm')]: {
            top: '24px',
            fontSize: '11px',
        },
    },
    uploadBtn: {
        width: '30px',
        fontSize: '10px !important',
        height: '20px',
        textTransform: 'capitalize',
        fontWeight: '400 !important',
    },
}));

export default function TrialBalanceSheetInnerContent({ letter, index, handleSave }) {
    const classes = useStyles();
    const history = useHistory();

    const navigate = () => {
        //console.log();
        history.push('/menu/addAdditional');
    };
    return (
        <>
            <Grid item sm={12} className={classes.fullWidth}>
                <div>
                    <ul className={classes.displayInline}>
                        <li>
                            <Button variant="outlined" className="btnBlue ml10 txt-cap" color="primary" onClick={navigate}>
                                CPS Checklist
                            </Button>
                        </li>
                    </ul>
                </div>
            </Grid>
            <Card className={classes.root}>
                <CardContent className={classes.cardCustom} style={{ paddingBottom: '0' }}>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth>
                                <InputLabel className="lbl" htmlFor="firstname" shrink>
                                    {' '}
                                    Action
                                </InputLabel>

                                <Select
                                    native
                                    className="bottom "
                                    name="intclientName"
                                    // onChange={setImc}
                                    // value={selectedImc}
                                >
                                    <option value="" selected hidden>
                                        To send to Client (Orange)
                                    </option>
                                    {/* {allImcsOptions(AllImcs)} */}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth>
                                <InputLabel className="lbl" htmlFor="audit" shrink>
                                    {' '}
                                    Remarks by Audit Team
                                </InputLabel>
                                <Input
                                    type="text"
                                    placeholder="Enter Remarks"
                                    className="bottom"
                                    name="audit"
                                    // onChange={formik.handleChange}
                                    // onBlur={formik.handleBlur}
                                    // value={formik.values.gstin}
                                />

                                <div className={classes.btnFieldPositionRight}>
                                    <Button variant="outlined" color="primary" className={classes.uploadBtn}>
                                        Upload
                                    </Button>
                                </div>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth>
                                <InputLabel className="lbl" htmlFor="audit" shrink>
                                    {' '}
                                    Remarks by Client
                                </InputLabel>
                                <Input
                                    type="text"
                                    placeholder="Enter Remarks"
                                    className="bottom"
                                    name="audit"
                                    // onChange={formik.handleChange}
                                    // onBlur={formik.handleBlur}
                                    // value={formik.values.gstin}
                                />

                                <div className={classes.btnFieldPositionRight}>
                                    <Button variant="outlined" color="primary" className={classes.uploadBtn}>
                                        Download
                                    </Button>
                                </div>
                            </FormControl>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            <Card className={classes.root}>
                <CardContent className={classes.cardCustom} style={{ paddingBottom: '0' }}>
                    <Grid container spacing={3} className="main-container">
                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth>
                                <InputLabel className="lbl" htmlFor="firstname" shrink>
                                    {' '}
                                    Action
                                </InputLabel>

                                <Select
                                    native
                                    className="bottom "
                                    name="intclientName"
                                    // onChange={setImc}
                                    // value={selectedImc}
                                >
                                    <option value="" selected hidden>
                                        To send to Client (Orange)
                                    </option>
                                    {/* {allImcsOptions(AllImcs)} */}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth>
                                <InputLabel className="lbl" htmlFor="audit" shrink>
                                    {' '}
                                    Remarks by Audit Team
                                </InputLabel>
                                <Input
                                    type="text"
                                    placeholder="Enter Remarks"
                                    className="bottom"
                                    name="audit"
                                    // onChange={formik.handleChange}
                                    // onBlur={formik.handleBlur}
                                    // value={formik.values.gstin}
                                />

                                <div className={classes.btnFieldPositionRight}>
                                    <Button variant="outlined" color="primary" className={classes.uploadBtn}>
                                        Upload
                                    </Button>
                                </div>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <FormControl fullWidth>
                                <InputLabel className="lbl" htmlFor="audit" shrink>
                                    {' '}
                                    Remarks by Client
                                </InputLabel>
                                <Input
                                    type="text"
                                    placeholder="Enter Remarks"
                                    className="bottom"
                                    name="audit"
                                    // onChange={formik.handleChange}
                                    // onBlur={formik.handleBlur}
                                    // value={formik.values.gstin}
                                />

                                <div className={classes.btnFieldPositionRight}>
                                    <Button variant="outlined" color="primary" className={classes.uploadBtn}>
                                        Download
                                    </Button>
                                </div>
                            </FormControl>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </>
    );
}
